export class Marker {
    marker;
    constructor(marker) {
        this.marker = marker;
    }
    getContent() {
        return this.marker.element?.firstChild?.firstChild;
    }
    setLatLng(latLng) {
        this.marker.position = latLng;
    }
    /**
     * Call this method when it has to be removed and or needs to be destroyed
     */
    remove() {
        this.marker.map = undefined;
    }
    /**
     * Call this method in order to add this layer to the given map.
     * @param map The map where to add this layer to.
     */
    addTo(map) {
        if (map && this.marker.map !== map) {
            this.marker.map = map;
        }
    }
}
